import throttle from "./throttle";

var getPadding = function getPadding(element) {
  return element ? parseFloat(getComputedStyle(element).paddingBottom) : 0;
};

var getHeight = function getHeight(element, top) {
  return top === 'auto' ? element.offsetHeight - getPadding(element) : window.innerHeight - top;
};

export var transform = function transform(element, value) {
  if (element) {
    var y = value === 'auto' ? '100%' : value; // eslint-disable-next-line no-param-reassign

    element.style.transform = "translateY(".concat(y, ")");
  }
};
export var calculate = function calculate(popup, top) {
  var addendum = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var withKeyboard = arguments.length > 3 ? arguments[3] : undefined;
  var translation;

  if (top === 'auto') {
    translation = getPadding(popup) + addendum;
  } else {
    translation = popup.offsetHeight + parseFloat(top) + addendum - window.innerHeight;
  }

  if (withKeyboard) {
    translation = popup.offsetHeight - window.innerHeight;
  }

  return "".concat(translation, "px");
};
export var setupSwipeDown = function setupSwipeDown(_ref) {
  var anchor = _ref.anchor,
      element = _ref.element,
      _ref$moveDelay = _ref.moveDelay,
      moveDelay = _ref$moveDelay === void 0 ? 90 : _ref$moveDelay,
      onSwipeDown = _ref.onSwipeDown,
      _ref$partOfHeightToSw = _ref.partOfHeightToSwipeDown,
      partOfHeightToSwipeDown = _ref$partOfHeightToSw === void 0 ? 4 : _ref$partOfHeightToSw,
      top = _ref.top,
      _ref$transformToEnd = _ref.transformToEnd,
      transformToEnd = _ref$transformToEnd === void 0 ? false : _ref$transformToEnd;
  var ended = false;
  var y = null;
  var diff = null;
  var swipeAnchor = anchor || element;

  var handleTouchStart = function handleTouchStart(e) {
    var touch = e.touches && e.touches[0];

    if (touch) {
      ended = false;
      y = touch.screenY;
    }
  };

  var handleTouchMove = throttle(function (e) {
    var touch = e.touches && e.touches[0];

    if (touch && y !== null) {
      diff = touch.screenY - y;

      if (!ended) {
        transform(element, calculate(element, top, diff));
      }
    }
  }, moveDelay);

  var handleTouchEnd = function handleTouchEnd() {
    ended = true;

    if (diff > getHeight(element, top) / partOfHeightToSwipeDown && diff !== null) {
      y = null;

      if (transformToEnd) {
        transform(element, '100%');
        setTimeout(function () {
          onSwipeDown();
        }, 110);
      } else {
        onSwipeDown();
      }
    } else {
      transform(element, calculate(element, top));
    }
  };

  var handleWindowResize = throttle(function () {
    var activeEl = document.activeElement;

    if (activeEl.tagName === 'INPUT') {
      transform(element, calculate(element, top, 0, true));
    } else {
      transform(element, calculate(element, top));
    }
  }, 90);
  window.addEventListener('resize', handleWindowResize, false);
  swipeAnchor.addEventListener('touchstart', handleTouchStart, false);
  swipeAnchor.addEventListener('touchmove', handleTouchMove, false);
  swipeAnchor.addEventListener('touchend', handleTouchEnd, false);
  return function () {
    window.removeEventListener('resize', handleWindowResize, false);
    swipeAnchor.removeEventListener('touchstart', handleTouchStart, false);
    swipeAnchor.removeEventListener('touchmove', handleTouchMove, false);
    swipeAnchor.removeEventListener('touchend', handleTouchEnd, false);
  };
};